
const IMG = [
  "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80",
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80",
  "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80",
];



import axios from "axios";
import { getToken } from "./authService";

const API_URL = process.env.REACT_APP_API_URL;
const getAuthToken = () => {
  const user = JSON.parse(localStorage.getItem("user") || "null");
  return user?.token || localStorage.getItem("token") || null;
};
const authHeaders = () => {
  const token = getToken();
  return token
    ? { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
};

const handleError = (error, fallback) => {
  const message =
    error.response?.data?.message ||
    error.response?.data?.error ||
    fallback;
  throw new Error(message);
};

/** Map API city → UI shape */
export const mapCity = (c) => ({
  id: c.id,
  name: c.cityname?.trim() || c.name || "",
  cityname: c.cityname?.trim() || c.name || "",
  state: c.state || "",
  rera: c.rera || "",
  isActive: c.isActive !== false,
  slug: (c.cityname || c.name || "")
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-"),
});

/** GET {{API_URL}}/cities/getcities */
export const getCities = async () => {
  try {
    const { data } = await axios.get(`${API_URL}/cities/getcities`, {
      // headers: authHeaders(),
    });
    const list = data.cities || data || [];
    return list.map(mapCity);
  } catch (error) {
    handleError(error, "Failed to load cities");
  }
};

/** GET {{API_URL}}/cities/getcity/:id */
export const getCityById = async (id) => {
  try {
    const { data } = await axios.get(`${API_URL}/cities/getcity/${id}`, {
      // headers: authHeaders(),
    });
    const city = data.city || data;
    return mapCity(city);
  } catch (error) {
    handleError(error, "Failed to load city");
  }
};

/** POST {{API_URL}}/cities/addcity */
export const addCity = async ({ name, state, rera }) => {
  try {
    const { data } = await axios.post(
      `${API_URL}/cities/addcity`,
      {
        cityname: name.trim(),
        state: state.trim(),
        rera: rera?.trim() || "",
      },
      { headers: authHeaders() }
    );
    return {
      message: data.message || "City added successfully",
      city: mapCity(data.city || data),
    };
  } catch (error) {
    handleError(error, "Failed to add city");
  }
};

/** PUT {{API_URL}}/cities/updatecity/:id */
export const updateCity = async (id, { name, state, rera }) => {
  try {
    const { data } = await axios.put(
      `${API_URL}/cities/updatecity/${id}`,
      {
        cityname: name.trim(),
        state: state.trim(),
        rera: rera?.trim() || "",
      },
      { headers: authHeaders() }
    );
    return {
      message: data.message || "City updated successfully",
      city: mapCity(data.city || data),
    };
  } catch (error) {
    handleError(error, "Failed to update city");
  }
};

/** DELETE {{API_URL}}/cities/deletecity/:id */
export const deleteCity = async (id) => {
  try {
    const { data } = await axios.delete(
      `${API_URL}/cities/deletecity/${id}`,
      { headers: authHeaders() }
    );
    return data;
  } catch (error) {
    handleError(error, "Failed to delete city");
  }
};


// developres master data 

// const getToken = () => {
//   try {
//     const user = JSON.parse(localStorage.getItem("user") || "null");
//     return user?.token || localStorage.getItem("token") || null;
//   } catch {
//     return null;
//   }
// };


const parseError = async (response) => {
  try {
    const errorData = await response.json();
    return errorData.message || errorData.error || `Server error: ${response.status}`;
  } catch {
    return `Server error: ${response.status}`;
  }
};

/** Map API → UI */
export const mapDeveloper = (d) => ({
  id: d.id,
  name: d.developerName || d.name || "",
  developerName: d.developerName || d.name || "",
  description: d.description || "",
  isActive: d.isActive !== false,
});

/** GET {{API_URL}}/developers/getdeveloper */
export const getDevelopers = async () => {
  try {
    const response = await fetch(`${API_URL}/developers/getdevelopers`, {
      method: "GET",
      headers: authHeaders(),
    });

    if (!response.ok) throw new Error(await parseError(response));

    const data = await response.json();
    const list = data.developers || data || [];
    return list.map(mapDeveloper);
  } catch (error) {
    console.error("Get developers failed:", error);
    throw error;
  }
};

/** GET {{API_URL}}/developers/getdeveloper/:id */
export const getDeveloperById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/developers/getdeveloper/${id}`, {
      method: "GET",
      headers: authHeaders(),
    });

    if (!response.ok) throw new Error(await parseError(response));

    const data = await response.json();
    return mapDeveloper(data.developer || data);
  } catch (error) {
    console.error("Get developer failed:", error);
    throw error;
  }
};

/** POST {{API_URL}}/developers/adddeveloper */
export const addDeveloper = async ({ name, description }) => {
  try {
    const response = await fetch(`${API_URL}/developers/adddeveloper`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({
        developerName: name.trim(),
        description: description?.trim() || "",
      }),
    });

    if (!response.ok) throw new Error(await parseError(response));

    const data = await response.json();
    return {
      message: data.message || "Developer added successfully",
      developer: mapDeveloper(data.developer || data),
    };
  } catch (error) {
    console.error("Add developer failed:", error);
    throw error;
  }
};

/** PUT {{API_URL}}/developers/updatedeveloper/:id */
export const updateDeveloper = async (id, { name, description }) => {
  try {
    const response = await fetch(
      `${API_URL}/developers/updatedeveloper/${id}`,
      {
        method: "PUT", // change to POST if your API uses POST
        headers: authHeaders(),
        body: JSON.stringify({
          developerName: name.trim(),
          description: description?.trim() || "",
        }),
      }
    );

    if (!response.ok) throw new Error(await parseError(response));

    const data = await response.json();
    return {
      message: data.message || "Developer updated successfully",
      developer: mapDeveloper(data.developer || data),
    };
  } catch (error) {
    console.error("Update developer failed:", error);
    throw error;
  }
};

/** DELETE {{API_URL}}/developers/deletedeveloper/:id */
export const deleteDeveloper = async (id) => {
  try {
    const response = await fetch(
      `${API_URL}/developers/deletedeveloper/${id}`,
      {
        method: "DELETE",
        headers: authHeaders(),
      }
    );

    if (!response.ok) throw new Error(await parseError(response));

    return await response.json().catch(() => ({ message: "Developer deleted" }));
  } catch (error) {
    console.error("Delete developer failed:", error);
    throw error;
  }
};



// amenities master data-----------------------------------------------------------------------------------------------------------------------------------//


export const mapAmenity = (a) => ({
  id: a.id,
  name: a.name || "",
  isActive: a.isActive !== false,
});

/** GET {{API_URL}}/amenities/getamenities */
export const getAmenities = async () => {
  try {
    const response = await fetch(`${API_URL}/amenities/getamenities`, {
      method: "GET",
      headers: authHeaders(),
    });

    if (!response.ok) throw new Error(await parseError(response));

    const data = await response.json();
    const list = data.amenitiesList || data.amenities || data || [];
    return list.map(mapAmenity);
  } catch (error) {
    console.error("Get amenities failed:", error);
    throw error;
  }
};

/** GET {{API_URL}}/amenities/getamenity/:id */
export const getAmenityById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/amenities/getamenity/${id}`, {
      method: "GET",
      headers: authHeaders(),
    });

    if (!response.ok) throw new Error(await parseError(response));

    const data = await response.json();
    return mapAmenity(data.amenitie || data.amenity || data);
  } catch (error) {
    console.error("Get amenity failed:", error);
    throw error;
  }
};

/** POST {{API_URL}}/amenities/addamenitie */
export const addAmenity = async ({ name }) => {
  try {
    const response = await fetch(`${API_URL}/amenities/addamenitie`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({ name: name.trim() }),
    });

    if (!response.ok) throw new Error(await parseError(response));

    const data = await response.json();
    return {
      message: data.message || "Amenity added successfully",
      amenity: mapAmenity(data.amenitie || data.amenity || data),
    };
  } catch (error) {
    console.error("Add amenity failed:", error);
    throw error;
  }
};

/** PUT {{API_URL}}/amenities/updateamenity/:id */
export const updateAmenity = async (id, { name }) => {
  try {
    const response = await fetch(`${API_URL}/amenities/updateamenity/${id}`, {
      method: "PUT", // change to POST if your API uses POST
      headers: authHeaders(),
      body: JSON.stringify({ name: name.trim() }),
    });

    if (!response.ok) throw new Error(await parseError(response));

    const data = await response.json();
    return {
      message: data.message || "Amenity updated successfully",
      amenity: mapAmenity(data.amenitie || data.amenity || data),
    };
  } catch (error) {
    console.error("Update amenity failed:", error);
    throw error;
  }
};

/** DELETE {{API_URL}}/amenities/deleteamenity/:id */
export const deleteAmenity = async (id) => {
  try {
    const response = await fetch(`${API_URL}/amenities/deleteamenity/${id}`, {
      method: "DELETE",
      headers: authHeaders(),
    });

    if (!response.ok) throw new Error(await parseError(response));

    return await response
      .json()
      .catch(() => ({ message: "Amenity deleted" }));
  } catch (error) {
    console.error("Delete amenity failed:", error);
    throw error;
  }
};



// ------------------------------------addproperty master data-------------------------------------------------------------------------------------------------------//.



const authHeadersFormData = (isFormData = false) => {
  const token = getToken();
  if (!token) throw new Error("No authentication token found");
  const headers = { Authorization: `Bearer ${token}` };
  // Do NOT set Content-Type for FormData — browser sets boundary
  if (!isFormData) headers["Content-Type"] = "application/json";
  return headers;
};

// const parseError = async (response) => {
//   try {
//     const errorData = await response.json();
//     return (
//       errorData.message ||
//       errorData.error ||
//       `Server error: ${response.status}`
//     );
//   } catch {
//     return `Server error: ${response.status}`;
//   }
// };

/** Build FormData matching your Postman shape */
export function buildPropertyFormData(payload) {
  const fd = new FormData();

  const fields = [
    "title",
    "city",
    "developer",
    "locality",
    "country",
    "Price",
    "address",
    "category",
    "subType",
    "rera",
    "possessionStatus",
    "description",
    "disclaimer",
    "status",
  ];

  fields.forEach((key) => {
    const val = payload[key];
    if (val !== undefined && val !== null) {
      fd.append(key, String(val).trim());
    }
  });

  // Booleans
  fd.append("featured", String(!!payload.featured));
  fd.append("exclusive", String(!!payload.exclusive));
  fd.append("luxurious", String(!!payload.luxurious));
  fd.append("isActive", String(payload.status === "Published"));

  // Arrays → JSON strings
  fd.append(
    "keyFeatures",
    JSON.stringify((payload.keyFeatures || []).filter((s) => s?.trim()))
  );
  fd.append(
    "locationAdvantages",
    JSON.stringify(
      (payload.locationAdvantages || []).filter((s) => s?.trim())
    )
  );
  fd.append(
    "landmarks",
    JSON.stringify(
      (payload.landmarks || [])
        .filter((l) => l.name?.trim())
        .map(({ name, distance, travelTime }) => ({
          name: name.trim(),
          distance: distance || "",
          ...(travelTime ? { travelTime } : {}),
        }))
    )
  );
  fd.append(
    "lifestyleScores",
    JSON.stringify(
      (payload.lifestyleScores || [])
        .filter((s) => s.category?.trim())
        .map(({ category, score }) => ({
          category: category.trim(),
          score: Number(score) || 0,
        }))
    )
  );
  fd.append(
    "amenities",
    JSON.stringify(payload.amenities || [])
  );

  // Units + floor plan files
  // Collect File objects for floor plans; units JSON uses floorPlanIndex
  // const floorPlanFiles = [];
  // const unitsPayload = (payload.units || [])
  //   .filter((u) => u.unitType)
  //   .map((u) => {
  //     let floorPlanIndex = -1;
  //     if (u.floorPlanFile instanceof File) {
  //       floorPlanIndex = floorPlanFiles.length;
  //       floorPlanFiles.push(u.floorPlanFile);
  //     }
  //     return {
  //       unitType: u.unitType,
  //       area: Number(u.area) || 0,
  //       price: Number(u.price) || 0,
  //       floorPlanIndex,
  //     };
  //   });

  // fd.append("units", JSON.stringify(unitsPayload));

  // ---- Images (update-safe) ----
// Remaining S3 URLs after user removed some in the UI
fd.append(
  "existingImages",
  JSON.stringify(
    Array.isArray(payload.existingImages) ? payload.existingImages : []
  )
);

// S3 URLs user removed (backend can delete from bucket)
fd.append(
  "removedImages",
  JSON.stringify(
    Array.isArray(payload.removedImages) ? payload.removedImages : []
  )
);

// New uploads only (File objects)
(payload.imageFiles || []).forEach((file) => {
  if (file instanceof File) {
    fd.append("images", file);
  }
});

 // ---------- UNITS + FLOOR PLANS ----------
  const floorPlanFiles = [];
  const unitsPayload = (payload.units || []).map((u) => {
    const row = {
      unitType: u.unitType,
      area: Number(u.area) || 0,
      price: Number(u.price) || 0,
    };

    if (u.floorPlanFile instanceof File) {
      row.floorPlanIndex = floorPlanFiles.length;
      floorPlanFiles.push(u.floorPlanFile);
    } else if (u.floorPlan && String(u.floorPlan).startsWith("http")) {
      // keep existing floor plan URL (clean)
      row.floorPlan = u.floorPlan;
      row.floorPlanIndex = -1;
    } else {
      row.floorPlanIndex = -1;
    }

    return row;
  });

  fd.append("units", JSON.stringify(unitsPayload));

  // Only append files when user actually selected new floor plans
  floorPlanFiles.forEach((file) => {
    fd.append("floorPlans", file);
  });

  return fd;
}

/** POST {{API_URL}}/properties/addpropertie  (form-data) */
export const addProperty = async (payload) => {
  try {
    const fd = buildPropertyFormData(payload);
    const response = await fetch(`${API_URL}/properties/addpropertie`, {
      method: "POST",
      headers: authHeadersFormData(true),
      body: fd,
    });

    if (!response.ok) throw new Error(await parseError(response));

    return await response.json();
  } catch (error) {
    console.error("Add property failed:", error);
    throw error;
  }
};

/** GET {{API_URL}}/properties/getproperties */
export const getProperties = async () => {
  try {
    const response = await fetch(`${API_URL}/properties/getproperties`, {
      method: "GET",
      // headers: authHeadersFormData(),
    });

    if (!response.ok) throw new Error(await parseError(response));

    const data = await response.json();
    return data.data || data.properties || data || [];
  } catch (error) {
    console.error("Get properties failed:", error);
    throw error;
  }
};

/** GET {{API_URL}}/properties/getpropertie/:id */
export const getPropertyById = async (id) => {
  try {
    const response = await fetch(
      `${API_URL}/properties/getpropertie/${id}`,
      {
        method: "GET",
        // headers: authHeadersFormData(),
      }
    );

    if (!response.ok) throw new Error(await parseError(response));

    const data = await response.json();
    return data.data || data.property || data;
  } catch (error) {
    console.error("Get property failed:", error);
    throw error;
  }
};

/** PUT {{API_URL}}/properties/updatepropertie/:id  (form-data) */
export const updateProperty = async (id, payload) => {
  try {
    const fd = buildPropertyFormData(payload);
    const response = await fetch(
      `${API_URL}/properties/updatepropertie/${id}`,
      {
        method: "PUT", // use POST if your API expects POST
        headers: authHeadersFormData(true),
        body: fd,
      }
    );

    if (!response.ok) throw new Error(await parseError(response));

    return await response.json();
  } catch (error) {
    console.error("Update property failed:", error);
    throw error;
  }
};

/** DELETE {{API_URL}}/properties/deletepropertie/:id */
export const deleteProperty = async (id) => {
  try {
    const response = await fetch(
      `${API_URL}/properties/deletepropertie/${id}`,
      {
        method: "DELETE",
        headers: authHeadersFormData(),
      }
    );

    if (!response.ok) throw new Error(await parseError(response));

    return await response.json().catch(() => ({ message: "Deleted" }));
  } catch (error) {
    console.error("Delete property failed:", error);
    throw error;
  }
};




//----------contact us form api----------------------------//


/** POST {{API_URL}}/contact  (or your real path, e.g. /enquiries/add) */
export const submitEnquiry = async ({ name, email, phone, message, property }) => {
  try {
    const body = {
      name: name.trim(),
      email: email.trim(),
      phone: phone.trim(),
      message: message.trim(),
    };

    // property only when coming from property details
    if (property && String(property).trim()) {
      body.property = String(property).trim();
    }

    const response = await fetch(`${API_URL}/contacts/addcontact`, {
      // change path if your backend is different, e.g. /enquiries/addenquiry
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      let msg = `Server error: ${response.status}`;
      try {
        const err = await response.json();
        msg = err.message || err.error || msg;
      } catch {
        /* ignore */
      }
      throw new Error(msg);
    }

    return await response.json();
  } catch (error) {
    console.error("Enquiry submit failed:", error);
    throw error;
  }
};